import { createApiInstance } from '@/lib/genericApi';

/** Public marketing brochure APIs — no auth token, no login redirect on 401. */
const publicBrochureApi = createApiInstance({
  getToken: () => undefined,
  errorHandler: () => {
    // Intentionally no redirect, cookie clearing, or toast — handled by brochure service.
  },
});

export default publicBrochureApi;
